import { AbstractClient, CompositionClient } from "@/app/client";
import { UUID } from "node:crypto";
import {
  RouteCreate,
  RouteUpdate,
  RouteResponse,
  RouteFilter,
} from "../types/route";

export default class APIRoutes extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  create = async (routeData: RouteCreate): Promise<RouteResponse> => {
    let res = await this._fetch({
      url: `/routes/`,
      method: "POST",
      body: routeData,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  list = async (filter?: RouteFilter): Promise<RouteResponse[]> => {
    let params: any = {};
    if (filter) {
      if (filter.is_active !== undefined) params.active_only = filter.is_active;
    }

    let res = await this._fetch({
      url: `/routes/`,
      method: "GET",
      params,
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  get = async (routeId: UUID): Promise<RouteResponse> => {
    let res = await this._fetch({
      url: `/routes/${routeId}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  update = async (
    routeId: UUID,
    routeData: RouteUpdate,
  ): Promise<RouteResponse> => {
    let res = await this._fetch({
      url: `/routes/${routeId}`,
      method: "PUT",
      body: routeData,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  delete = async (routeId: UUID): Promise<void> => {
    await this._fetch({
      url: `/routes/${routeId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
  };
}
